var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.3@core-js/library/modules/_cof.js
// module id = 115
// module chunks = 0 1